import { ITableColumn } from '@components/common/UTable/UTable';
import { Link } from 'react-router';

import { REPORT, TASK } from '@/constants/routes';
import {
  amountCols,
  indexCol,
  rateCol,
  reasonsCol,
} from '@/pages/Report/columns/commonColumns';

export const freeColumns = (dateAt: string) =>
  [
    indexCol,
    {
      title: 'Хозяйство',
      dataIndex: 'organizationName',
      key: 'organizationName',
      sorter: true,
      width: 150,
      render: (value, record) => (
        <Link
          style={{ color: '#046094', textDecoration: 'underline' }}
          to={
            REPORT +
            TASK +
            `?organizationId=${record.organizationId}` +
            `&orgName=${record.organizationName}` +
            `&dateAtFrom=${dateAt}` +
            `&dateAtTo=${dateAt}`
          }>
          {value}
        </Link>
      ),
    },
    ...amountCols(),
    reasonsCol,
    rateCol(),
  ] as ITableColumn[];
